module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/person1-dbba9c84af2a10fe335b49f28570273d.png";